import { ImageResolver, ShareDataRow } from '@alfresco/adf-content-services';
import { DataColumn } from '@alfresco/adf-core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PipeServiceImpl } from "pipe-service/pipe-service-impl";
import { UdeuService } from '../../services/udeu.service';
import { hasAspect } from 'projects/alden-extension/src/lib/rules/alden.rules';
import { BORROWED_RECORD_ASPECT } from '../../model/contants/deusto';
import { ActivatedRoute, Router } from '@angular/router';
import { RecordService } from '../../services/record.service';
import { RecordActionTypes } from '../../store/actions/record-actions';

@Component({
    templateUrl: './records.component.html',
    styleUrls: ['./records.component.scss'],
})
export class RecordsComponent implements OnInit, OnDestroy { 

    //Nombre de la confituración del visor en el json
    viewerConfigId: string = "deusto-records-viewer";

    loading: boolean;

    constructor(private udeuService: UdeuService, private pipeService: PipeServiceImpl, 
        private route: ActivatedRoute, private router: Router, private recordService: RecordService) {}

    async ngOnInit(): Promise<void> {
        this.loading = true;
        await this.udeuService.getProfileState();

        const UUID = this.route.snapshot.paramMap.get('uuid');
        if(UUID) {
            // Eliminar el parámetro de la URL
            this.router.navigate(['../'], { relativeTo: this.route }); 
            // Abrimos la transferencia
            this.recordService.openRecordDialogComponent([UUID], RecordActionTypes.ViewRecord, true);
        }

        this.loading = false;
    }

    ngOnDestroy(): void {
        // Necesitamos limpiar los maps por si han actualizado algún valor
        this.pipeService.refreshMaps();
    }

    customImageResolver: ImageResolver  = (row: ShareDataRow, col: DataColumn) => {
        if (col.id == "deusto-records-viewer.borrowed") {
            if(hasAspect(row.node, BORROWED_RECORD_ASPECT)) {
                return 'assets/deusto-extension/images/assignment_turned_in.svg';
            }
        }
        return null;
    }; 
    
}